import React, { useState } from "react";
import styles from "./Faq.module.css";

const FAQS = [
  {
    q: "What areas do you serve?",
    a: "We cover homes, offices and shops across the areas we operate in. Message us on WhatsApp with your location and we'll confirm right away.",
  },
  {
    q: "How much does a cleaning or renovation job cost?",
    a: "It depends on the size of the property and the scope of work. Send us a few details and photos on WhatsApp and we'll reply with a clear, no-obligation quote.",
  },
  {
    q: "How do I book a service?",
    a: "Just message us on WhatsApp with what you need done. We'll confirm the scope, give you a quote, and schedule a date and time that works for you.",
  },
  {
    q: "Do you provide your own equipment and materials?",
    a: "For cleaning jobs, yes — our team brings their own tools and supplies. For renovation work, we'll go through the materials needed with you before starting.",
  },
  {
    q: "Can I book a one-time job or a recurring service?",
    a: "Both. We take one-off jobs as well as recurring cleaning or maintenance visits on a schedule that suits you.",
  },
  {
    q: "Is a deposit required for renovation work?",
    a: "For larger renovation jobs, a deposit may be required before work starts. We'll confirm this clearly as part of your quote.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <section id="faq" className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <p className="jc-eyebrow">FAQ</p>
          <h2 className={styles.title}>Questions we get asked most</h2>
        </div>

        <div className={styles.list}>
          {FAQS.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                className={`${styles.item} ${isOpen ? styles.itemOpen : ""}`}
                key={item.q}
              >
                <button
                  type="button"
                  className={styles.question}
                  aria-expanded={isOpen}
                  onClick={() => toggle(index)}
                >
                  {item.q}
                  <span className={styles.icon} aria-hidden="true">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
                {isOpen && <p className={styles.answer}>{item.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
